document.addEventListener("DOMContentLoaded", () => {
    const statusDot = document.getElementById('store-status-dot');
    const statusText = document.getElementById('store-status-text');
    const statusContainer = document.getElementById('store-status-indicator');

    if (!statusContainer) return;

    function checkStoreStatus() {
        // Get current time in Italy timezone
        const options = { timeZone: 'Europe/Rome', hour: '2-digit', minute: '2-digit', weekday: 'long' };
        const formatter = new Intl.DateTimeFormat('it-IT', options);
        
        // Actually, getting exact parts is better
        const now = new Date();
        const italyTimeStr = now.toLocaleString("en-US", { timeZone: "Europe/Rome" });
        const italyDate = new Date(italyTimeStr);
        
        const day = italyDate.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        const hours = italyDate.getHours();
        const minutes = italyDate.getMinutes();
        
        const currentTotalMinutes = hours * 60 + minutes;
        
        let isOpen = false;
        
        // Mon-Fri (1-5)
        if (day >= 1 && day <= 5) {
            const morningStart = 8 * 60; // 08:00
            const morningEnd = 12 * 60 + 45; // 12:45
            const afternoonStart = 15 * 60; // 15:00
            const afternoonEnd = 19 * 60; // 19:00
            
            if ((currentTotalMinutes >= morningStart && currentTotalMinutes < morningEnd) ||
                (currentTotalMinutes >= afternoonStart && currentTotalMinutes < afternoonEnd)) {
                isOpen = true;
            }
        }
        // Saturday (6)
        else if (day === 6) {
            const morningStart = 8 * 60; // 08:00
            const morningEnd = 12 * 60 + 45; // 12:45
            
            if (currentTotalMinutes >= morningStart && currentTotalMinutes < morningEnd) {
                isOpen = true;
            }
        }
        // Sunday (0) is closed
        
        if (isOpen) {
            statusContainer.classList.add('is-open');
            statusContainer.classList.remove('is-closed');
            if(statusText) statusText.textContent = "Aperto Ora";
        } else {
            statusContainer.classList.add('is-closed');
            statusContainer.classList.remove('is-open');
            if(statusText) statusText.textContent = "Chiuso Ora";
        }
    }

    // Check immediately and then every 1 minute
    checkStoreStatus();
    setInterval(checkStoreStatus, 60000);
});
